const WhyWatch = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M18.1255 18.125L18.1255 5.625C18.1255 3.55393 16.4466 1.875 14.3755 1.875L5.62549 1.875C3.55442 1.875 1.87549 3.55393 1.87549 5.625L1.87549 18.125"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M8.12549 2.5L7.54749 6.25697C7.17519 8.67693 4.92431 10.3463 2.50049 10V10"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M11.8755 1.875L12.4602 5.67588C12.843 8.1636 14.9835 10 17.5005 10V10"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M14.3755 17.5V13.125C14.3755 11.3991 15.7746 10 17.5005 10V10"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M5.62549 17.5L5.62549 13.75C5.62549 11.6789 3.94656 10 1.87549 10V10"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M1.87549 18.125L18.1255 18.125"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </svg>
);

export default WhyWatch;
